import { MaterialIcon } from 'shared/ui/MaterialIcon';
import classNames from 'classnames';
import { Tooltip } from 'shared/ui/Tooltip';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { Button } from 'shared/ui/Button';
import { HOLYDAY_SCHEDULE_QUERY_KEY } from 'pages/ContractorCampaigns';
import { useUrlResolver } from 'shared/lib/url';

import type { OnboardingStatus } from '../../model';

import { BadgeIcon } from './BadgeIcon';

interface GenericStepProps {
  status: OnboardingStatus;
  iconName: string;
  text: string;
  optional?: boolean;
  isLast?: boolean;
  tooltipText?: string;
}

export function HolidayStepCompleted({ status, iconName, text, tooltipText, isLast, optional }: GenericStepProps) {
  const isNotDone = status !== 'done';
  const { addParam } = useUrlResolver();
  const openHolidaySchedule = () => addParam(HOLYDAY_SCHEDULE_QUERY_KEY, '1');

  return (
    <div
      className={classNames(
        'flex w-[536px] border-b px-[25px] pt-[13px] items-center',
        isLast ? 'border-transparent' : 'border-slate-100'
      )}
    >
      <div className="flex w-[186px] items-start gap-2">
        <MaterialIcon className="text-base text-slate-900">{iconName}</MaterialIcon>
        <div className="relative flex flex-col pt-[2px]">
          <span className="text-sm text-slate-900">{text}</span>
          {optional && <span className="absolute top-5 block text-xs text-slate-300">(Optional)</span>}
        </div>
        {tooltipText && (
          <Tooltip
            placement="top"
            content={tooltipText}
            contentClass="!text-left"
          >
            <MaterialIcon className="ml-[-4px] mt-[4px] block cursor-pointer text-[16px] text-slate-300 hover:text-deep-blue-500">
              info
            </MaterialIcon>
          </Tooltip>
        )}
      </div>

      <BadgeIcon status={status} />
      <div className="ml-auto flex w-[149px] justify-center">
        {isNotDone ? (
          <Button
            iconLeftName="add_circle_outline"
            className="w-[149px]"
            variant="primary"
            size="small"
            onClick={openHolidaySchedule}
            {...getDataAutoTestAttributes(['button-add-holiday'])}
          >
            Add holidays
          </Button>
        ) : (
          <MaterialIcon className="text-[20px] text-deep-green-700">check</MaterialIcon>
        )}
      </div>
    </div>
  );
}
